/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ eventIndex: NonNullable<unknown> }} Event_Text_Editor_Aria_LabelInputs */

const en_event_text_editor_aria_label = /** @type {(inputs: Event_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Text editor for event ${i?.eventIndex}`)
};

const fr_event_text_editor_aria_label = /** @type {(inputs: Event_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Editeur de texte pour l'evenement ${i?.eventIndex}`)
};

const de_event_text_editor_aria_label = /** @type {(inputs: Event_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Texteditor für Ereignis ${i?.eventIndex}`)
};

const it_event_text_editor_aria_label = /** @type {(inputs: Event_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Editor di testo per l'evento ${i?.eventIndex}`)
};

const ru_event_text_editor_aria_label = /** @type {(inputs: Event_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Текстовый редактор для мероприятия ${i?.eventIndex}`)
};

const es_event_text_editor_aria_label = /** @type {(inputs: Event_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Editor de texto para el evento ${i?.eventIndex}`)
};

const zh_cn2_event_text_editor_aria_label = /** @type {(inputs: Event_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`事件 ${i?.eventIndex} 的文本编辑器`)
};

const ja_event_text_editor_aria_label = /** @type {(inputs: Event_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`イベント ${i?.eventIndex} のテキストエディター`)
};

const hi_event_text_editor_aria_label = /** @type {(inputs: Event_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`इवेंट ${i?.eventIndex} के लिए टेक्स्ट एडिटर`)
};

const pt_pt2_event_text_editor_aria_label = /** @type {(inputs: Event_Text_Editor_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Editor de texto para o evento ${i?.eventIndex}`)
};

/**
* | output |
* | --- |
* | "Text editor for event {eventIndex}" |
*
* @param {Event_Text_Editor_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_text_editor_aria_label = /** @type {((inputs: Event_Text_Editor_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Text_Editor_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_text_editor_aria_label(inputs)
	if (locale === "de") return de_event_text_editor_aria_label(inputs)
	if (locale === "it") return it_event_text_editor_aria_label(inputs)
	if (locale === "ru") return ru_event_text_editor_aria_label(inputs)
	if (locale === "es") return es_event_text_editor_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_event_text_editor_aria_label(inputs)
	if (locale === "ja") return ja_event_text_editor_aria_label(inputs)
	if (locale === "hi") return hi_event_text_editor_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_event_text_editor_aria_label(inputs)
	return en_event_text_editor_aria_label(inputs)
});